export type YearMonthParts = { year: number; month: number }

export function parseYearMonth(yearMonth: string): YearMonthParts {
  const match = /^(\d{4})-(\d{2})$/.exec(yearMonth)
  const month = match ? Number(match[2]) : 0
  if (!match || month < 1 || month > 12) throw new Error(`Malformed year-month: "${yearMonth}"`)
  return { year: Number(match[1]), month }
}

/**
 * The month as its first instant in UTC, for `formatDate(…, { timeZone: 'UTC' })`.
 *
 * The whole point is that no local zone gets to decide which month this is: these strings are
 * bucketed in the server's zone, so a reader in UTC-5 handed `new Date('2025-02')` renders
 * January. Format it in any other zone and the trap is back.
 */
export function yearMonthToUtcDate(yearMonth: string): Date {
  const { year, month } = parseYearMonth(yearMonth)
  return new Date(Date.UTC(year, month - 1, 1))
}
